var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 334,
    viewBox: "0 0 388 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 334,
    rx: 24,
    fill: "#FFF4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.211 163.95L194 124.919L195.789 163.95C195.853 165.333 197.595 165.9 198.459 164.818L222.849 134.293L201.354 166.921C200.593 168.077 201.67 169.56 203.005 169.193L240.679 158.833L204.111 172.596C202.815 173.084 202.815 174.916 204.111 175.404L240.679 189.167L203.005 178.807C201.67 178.44 200.593 179.923 201.354 181.079L222.849 213.707L198.459 183.182C197.595 182.1 195.853 182.667 195.789 184.05L194 223.081L192.211 184.05C192.147 182.667 190.405 182.1 189.541 183.182L165.151 213.707L186.646 181.079C187.407 179.923 186.33 178.44 184.995 178.807L147.321 189.167L183.889 175.404C185.185 174.916 185.185 173.084 183.889 172.596L147.321 158.833L184.995 169.193C186.33 169.56 187.407 168.077 186.646 166.921L165.151 134.293L189.541 164.818C190.405 165.9 192.147 165.333 192.211 163.95Z",
    stroke: "#BB34A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard6);
export default __webpack_public_path__ + "static/media/Card6.3826e78f14843fd55119ff4c44f30b65.svg";
export { ForwardRef as ReactComponent };